var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPercentageAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.23892V6.26093C1.49984 6.25358 1.49984 6.24624 1.5 6.23892Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 10.99V11.0091C1.49988 11.0027 1.49988 10.9963 1.5 10.99Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3536 13.3536C14.4473 13.2598 14.5 13.1326 14.5 13C14.5 12.8674 14.4473 12.7402 14.3536 12.6464C14.2598 12.5527 14.1326 12.5 14 12.5H2.5V11.4025L6.89442 10.4412L10.421 11.264C10.5411 11.2921 10.6669 11.2839 10.7824 11.2406L14.1756 9.96818C14.4341 9.87122 14.5651 9.58301 14.4682 9.32445C14.3712 9.06589 14.083 8.93489 13.8245 9.03185L10.5376 10.2644L7.0391 9.44808C6.94853 9.42695 6.85438 9.4263 6.76352 9.44617L2.5 10.3788V10.25V8.89812V6.61038L6.3957 5.31181L10.3554 8.57271C10.5801 8.75781 10.9029 8.76318 11.1337 8.58564L14.3049 6.14631C14.5237 5.97794 14.5647 5.66402 14.3963 5.44514C14.228 5.22626 13.914 5.18532 13.6952 5.35368L10.7606 7.61101L6.87125 4.40799C6.70517 4.27122 6.48041 4.22948 6.27629 4.29752L2.5 5.55629V3C2.5 2.86739 2.44732 2.74021 2.35355 2.64645C2.25979 2.55268 2.13261 2.5 2 2.5C1.86739 2.5 1.74021 2.55268 1.64645 2.64645C1.55268 2.74021 1.5 2.86739 1.5 3V6.23892V6.26093V10.99V11.0091V13C1.5 13.1326 1.55268 13.2598 1.64645 13.3536C1.74021 13.4473 1.86739 13.5 2 13.5H14C14.1326 13.5 14.2598 13.4473 14.3536 13.3536Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPercentageAreaIcon);
export default __webpack_public_path__ + "static/media/chart-percentage-area-icon.b3e93c2cbeee1088c0d5caf7eda2eae6.svg";
export { ForwardRef as ReactComponent };